
import { Component, Prop, Vue } from "vue-property-decorator";
import { systemSrv } from "./../services/system";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { notiSrv } from './../services/noti'

@Component({
  components: { Datepicker }
})
export default class ProfileForm extends Vue {
  memberAPIUrl = this.$store.getters.config.memberAPIUrl;
  profile = systemSrv.profile;
  formUser:any = {};
  processing = false;
  loadedProfile = false
  errorMessage = "";
  ic_type = "nric"
  CACHE_KEY_TOKEN = store.getters.tokenKeys.CACHE_KEY_TOKEN;
  tempProfile
  constructor() {
    super();
  }
  async created() {
     window.scrollTo(0,0);
    //let notiId = notiSrv.sayNoti("Loading profile", 50000)
    await systemSrv.initUser(true);
    //notiSrv.destroy(notiId)
    
    setTimeout(()=>{
      this.reloadProfile()
    })
  }
  reloadProfile(){
    this.profile = systemSrv.profile;
    this.loadedProfile = true
    this.formUser = Object.assign({}, this.profile);
    this.tempProfile = this.profile
    if(this.formUser['ic_type']){
      this.ic_type = this.formUser.ic_type
    }
    if(this.profile && this.profile['passport']){
      this.ic_type = "passport"
    }
    if(this.profile && !(this.profile['nric']||this.profile['passport'])){
      this.ic_type = "nric"
    }
    if(this.profile && this.profile['nric']){
      this.ic_type = "nric"
    }
    if(this.profile && this.profile['dynamicFieldLists']){
      this.profile['dynamicFieldLists'].forEach((dyF)=>{
        if(dyF.name=="webHotelID"){
          this.formUser.webHotelID = (dyF.colValue?String(dyF.colValue):"")
        }
      })
    }
        
    let date = new Date(this.formUser["dob"]);
    this.formUser["dob_"] = new Date(
      date.getTime() - new Date().getTimezoneOffset() * 60000
    ); 
  }

  updateDate(ev) {
    console.log(
      "Selected",
      ev,
      new Date(ev).getMonth(),
      new Date(ev).getMonth() + 1
    );
    this.formUser["dob"] =
      new Date(ev).getFullYear() +
      "-" +
      (new Date(ev).getMonth() + 1) +
      "-" +
      new Date(ev).getDate();
    console.log("Selected", this.formUser["dob"]);
  }
  async update() {
    this.processing = true;
    if (this.formUser["name"] && this.formUser["email"] && this.formUser["dob"]) {
      let token = cacheSrv.cached(this.CACHE_KEY_TOKEN);
      if (!token) {
        console.log("No token");
        router.push("login");
        return;
      }

      try {
        let dynamicFlds = [
          {name: "webHotelID", colValue:this.formUser.webHotelID}
        ]
        let payload = Object.assign({},this.formUser, {dynamicFieldLists:dynamicFlds})//
        let data = await systemSrv.updateUserProfile(payload);
        this.processing = false;
        if (data) {
          if (data["error"]) {
            console.log("Error updating profile");
            this.errorMessage = data["meta"].original.error.message;
            return;
          }
          let notiId = notiSrv.sayNoti("Profile updated", 2000)
        } else {
          console.log("Error in updating profile. No data");
        }
      } catch (error) {
        console.log("Error while updating profile. ", error);
        this.errorMessage = "Error while updating profile. " + error.error;
      }
    } else {
      console.log("Error. Form invalid");
      this.processing = false;
    }
  }
}
